import { FunctionComponent } from "react";
import PageLayout from "@components/core/layouts/PageLayout";
import { useTranslation } from "react-i18next";
import LinkButton from "@components/core/links/LinkButton";
import { ROUTES } from "@routes/Routes";
import CardSection from "@components/core/section/CardSection";
import { officeTransferStore as OTStore } from "@/state/officeTransfer/OfficeTransferStore";
import { OfficeTransferStore } from "@/type/core/officeTransfer/officeTransfer.types";
import { useUnit } from "effector-react";

const OfficeTransferRefusedScreen: FunctionComponent = () => {
  const { t } = useTranslation();
  const officeTransferStore = useUnit<OfficeTransferStore | null>(OTStore);
  const alreadyTreated = officeTransferStore?.alreadyTreated;

  return (
    <PageLayout container bodyClassName="mt-0">
      <CardSection
        title={
          alreadyTreated
            ? t("officeTransfer.refused.alreadyTreated.title")
            : t("officeTransfer.refused.title")
        }
        titleClassName="h1"
      >
        <>
          {alreadyTreated ? (
            <p>{t("officeTransfer.refused.alreadyTreated.description")}</p>
          ) : (
            <>
              <p className="text-danger">
                {t("officeTransfer.refused.success")}
              </p>
              <p>{t("officeTransfer.refused.successDescription")}</p>
            </>
          )}
          <div className="d-flex justify-content-center mt-48">
            <LinkButton
              to={ROUTES.extranet.home.generate()}
              variant="tertiary"
              className="py-8 px-30 mh-42 font-extra-small"
              text={t("officeTransfer.back")}
            />
          </div>
        </>
      </CardSection>
    </PageLayout>
  );
};

export default OfficeTransferRefusedScreen;
